export class UserSelectedServicesModel {
    PackageId: number;
    Email: string;
    Services: any;
    OrderId: string;
}
